
const config = {
  interfaceUrl: process.env.REACT_APP_API_ROOT || "https://test2.lovense.com",
  getLang:process.env.REACT_APP_API_LNG || "https://test7.lovense.com",
  // interfaceUrl: "http://192.168.1.144:8088",
}

export default config;